<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.333 2.75a.583.583 0 0 0-.583.583v9.334a.583.583 0 0 0 .583.583H6a.75.75 0 0 1 0 1.5H3.333a2.083 2.083 0 0 1-2.083-2.083V3.333A2.083 2.083 0 0 1 3.333 1.25H6a.75.75 0 0 1 0 1.5H3.333Zm6.803 1.386a.75.75 0 0 1 1.061 0L14.53 7.47a.75.75 0 0 1 0 1.06l-3.333 3.334a.75.75 0 0 1-1.06-1.061L12.938 8l-2.803-2.803a.75.75 0 0 1 0-1.06Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.25 8A.75.75 0 0 1 6 7.25h8a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 8Z"
      fill="currentColor"
    />
  </svg>
</template>
